@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header community-header">
  <div class="titles">
    <h3 class="title">المجتمعات</h3>
    <p class="subtitle">كوهورتات الندوات المرتبطة بالمشاريع العقارية</p>
  </div>
</div>

<div class="request-control mt-9" #goUp>
  <div class="right-side">
    <!-- Filter Component -->
    @if (filterData) {
      <app-filter
        [filterData]="filterData"
        [filterDataInit]="filterDataInit"
        [filterPage]="filterPage"
        (formValus)="filterFormValues($event)"
      >
      </app-filter>
    }

    <!-- Quick Search -->
    <quick-search
      [placeholder]="'ابحث بالمجتمع ...'"
      (searchResults)="quickSearch($any($event))"
    ></quick-search>
  </div>

  <div class="new-element">
    <button class="btn btn-add" (click)="goToAdd()">
      <img src="assets/images/svg/add-icon.svg" alt="" />
      إضافة مجتمع جديد
    </button>
  </div>
</div>

@if (communities && communities.length > 0) {
  <div class="request-table">
    <div class="table-responsive community-table">
      <table id="community-table" aria-label="" class="table table-striped">
        <thead>
          <tr>
            <th
              class="text-right sortable"
              (click)="toggleSorting('title', img1)"
            >
              العنوان
              <img #img1 [src]="imgDefault" alt="" class="sort-icon" />
            </th>
            <th
              class="text-right sortable"
              (click)="toggleSorting('code', img2)"
            >
              الرمز
              <img #img2 [src]="imgDefault" alt="" class="sort-icon" />
            </th>
            <th class="text-right">المشروع العقاري المرتبط</th>
            <th class="text-right">الحالة</th>
            <th class="text-center">عدد الطلبات</th>
            <th class="text-center">عدد الباقات</th>
            <th class="text-center actions-col">إجراءات</th>
          </tr>
        </thead>
        <tbody>
          @for (
            community of communities | paginate: config;
            track community.id
          ) {
            <tr
              class="table-row"
              (click)="goToDetails(community.id, community.title)"
            >
              <td class="text-right title">{{ community.title }}</td>
              <td class="text-right code">{{ community.code }}</td>
              <td class="text-right project-name">{{ community.project?.name }}</td>
              <td class="text-right">
                @if (community.is_active) {
                  <span class="status-badge status-active">نشط</span>
                } @else {
                  <span class="status-badge status-inactive">غير نشط</span>
                }
              </td>
              <td class="text-center">
                @if (community.ordersCount > 0) {
                  <a href="/pages/orders/orders-list?community={{ community.id }}">
                    <span class="count-link">{{ community.ordersCount }}</span>
                  </a>
                } @else {
                  <span class="no-data">-</span>
                }
              </td>
              <td class="text-center">
                @if (community.packagesCount > 0) {
                  <a href="/pages/pricing/list?community={{ community.id }}">
                    <span class="count-link">{{ community.packagesCount }}</span>
                  </a>
                } @else {
                  <span class="no-data">-</span>
                }
              </td>
              <td class="text-center actions-col">
                <div class="action-buttons">
                  <button class="btn-icon btn-view" (click)="viewCommunity($event, community.id)">
                    <img src="assets/images/svg/eye-icon.svg" alt="عرض" />
                  </button>
                  <button
                    class="btn-icon btn-edit"
                    (click)="editCommunity($event, community.id)"
                  >
                    <img src="assets/images/svg/edit-icon-2.svg" alt="تعديل" />
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <ayen-pagination
    (pageData)="pageChanged($event)"
    (pageSize)="pageSizeChanged($event)"
    [totalCount]="config.totalItems"
    [id]="'communityPagination'"
    [itemsPerPage]="config.itemsPerPage"
    (pageChange)="pageChanged($event)"
    [currentPage]="config.currentPage"
  >
  </ayen-pagination>
} @else if (!spinner) {
  <div class="no-data-message">
    <p>لا توجد مجتمعات حالياً</p>
  </div>
}
